import { render, staticRenderFns } from "./ImedicalForm.vue?vue&type=template&id=0c23a95e"
import script from "./ImedicalForm.vue?vue&type=script&lang=js"
export * from "./ImedicalForm.vue?vue&type=script&lang=js"
import style0 from "./ImedicalForm.vue?vue&type=style&index=0&id=0c23a95e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports